import { LockSimpleIcon } from '@phosphor-icons/react'
import type React from 'react'

/**
 * The lock-icon + amount/status row shared by every LockedAttachment text-mode
 * card. Only the wrapper and the leading lock icon are shared — the amount and
 * any trailing status live in `children`, since they genuinely differ per card
 * (placeholder fallback vs. paid badge vs. bare amount).
 */
const PriceLockRow: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="flex items-center gap-1 text-xs font-medium">
    <LockSimpleIcon
      className="size-3.5 shrink-0 opacity-55"
      weight="fill"
      aria-hidden
    />
    {children}
  </div>
)

export default PriceLockRow
